import { render, staticRenderFns } from "./addPlusBusiness.vue?vue&type=template&id=c4b0a090&scoped=true&lang=html"
import script from "./addPlusBusiness.vue?vue&type=script&lang=js"
export * from "./addPlusBusiness.vue?vue&type=script&lang=js"
import style0 from "./addPlusBusiness.vue?vue&type=style&index=0&id=c4b0a090&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b0a090",
  null
  
)

export default component.exports